import { HOME_DISMISS_ALL_NOTIFICATIONS } from './constants'

export function dismissAllNotifications() {
  return {
    type: HOME_DISMISS_ALL_NOTIFICATIONS,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_DISMISS_ALL_NOTIFICATIONS:
      return {
        ...state,
        dismissedNotifications: state.notifications,
        notifications: [],
      }

    default:
      return state
  }
}
